import * as TYPES from './types';

export const showLoadingIndicator = (key) => (
  {
    type: TYPES.SHOW_LOADING_INDICATOR,
    key,
  }
);

export const hideLoadingIndicator = (key) => (
  {
    type: TYPES.HIDE_LOADING_INDICATOR,
    key,
  }
);
